import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { SeoService } from '../../seo.services';

@Component({
  selector: 'app-productos',
  templateUrl: './productos.component.html',
  styleUrls: []
})
export class ProductosComponent implements OnInit {

  constructor(private title: Title, private seo: SeoService) { }

  ngOnInit() {
  	let t:string ="Sinuberase cuenta con una presentación que se adapta a cada paciente";
  	this.title.setTitle(t);

  	this.seo.generateTags({
  		title:"Sinuberase cuenta con una presentación que se adapta a cada paciente",
  		description: "Ese malestar de siempre: diarrea, gases o estreñimiento, no es normal. Los malos hábitos alimenticios, el estrés y tomar ciertos medicamentos repercuten en tu salud",
  		slug: "productos"
  	})

    this.seo.closeMenu();

  }

}
